import { render, staticRenderFns } from "./buyLog.vue?vue&type=template&id=487b9cc2&scoped=true&"
import script from "./buyLog.vue?vue&type=script&lang=js&"
export * from "./buyLog.vue?vue&type=script&lang=js&"
import style0 from "./buyLog.vue?vue&type=style&index=0&id=487b9cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b9cc2",
  null
  
)

export default component.exports